<template>
    <div class="feature-intro">
        <el-dialog
            :title="activeContent.title"
            :visible.sync="dialogVisible"
            :show-close="true"
            :append-to-body="true"
            :close-on-click-modal="false"
            custom-class="feature-intro__dialog"
            @close="resetCarouselIndex"
            :destroy-on-close="true"
            :top="dialogTopMargin"
        >
            <el-carousel
                arrow="never"
                :autoplay="false"
                trigger="click"
                indicator-position="none"
                ref="carousel"
                @change="carouselChange"
            >
                <el-carousel-item v-for="item in activeContent.content" :key="item.title">
                    <img
                        :src="
                            `${publicPath}/images/onboarding/${
                                mobile && item.srcMobile
                                    ? item.srcMobile
                                    : item.src
                            }`
                        "
                    />
                    <div class="feature-intro__text">
                        <p class="feature-intro__text__title">
                            {{ item.title }}
                        </p>
                        <p class="feature-intro__text__paragraph" v-html="item.paragraph"></p>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <SmrButton
                class="feature-intro__next-button"
                @click.native="toNextItem"
                v-if="carouselIndex !== activeContent.content.length - 1"
                >Weiter</SmrButton
            >
            <SmrButton
                class="feature-intro__close-button"
                @click.native="closeDialog"
                v-else
                >Fertig</SmrButton
            >
            <div class="feature-intro__indicators">
                <div
                    v-for="(indicator, index) in activeContent.content"
                    :key="indicator.title"
                    class="feature-intro__indicators__indicator"
                    :class="index === carouselIndex ? 'active' : ''"
                    @click="jumpToItem(index)"
                ></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus';
import SmrButton from '@/components/SmrButton.vue';

export default {
    components: {
        SmrButton,
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            dialogVisible: false,
            carouselIndex: 0,
            contents: {
                default: {
                    title: 'Neues im ÖAMTC Routenplaner',
                    content: [
                        {
                            src: 'feature-intro-item-0.jpg',
                            srcMobile: 'feature-intro-item-0-mobile.jpg',
                            title: 'Willkommen im neuen Routenplaner',
                            paragraph:
                                'Wir haben umgebaut: Frisches Design, neue Funktionen! Aber damit nicht genug: Wir entwickeln den ÖAMTC Routenplaner stetig weiter. Nicht nur im Web auch in der ÖAMTC App! <br>Wir freuen uns auf Ihr Feedback!',
                        },
                        {
                            src: 'feature-intro-item-1.jpg',
                            srcMobile: 'feature-intro-item-1-mobile.jpg',
                            title: 'Eine Routenplanung für alle Fälle',
                            paragraph:
                                'Egal, ob mit dem Wohnmobil nach Spanien oder mit den Öffis in die Arbeit - Planen Sie online Ihre Route für PKW, Öffis, Wohnmobil, Gespann, Fahrrad oder Fußgänger. Routenplanung für jede Lebenslage. Einfach gut ankommen!',
                        },
                        {
                            src: 'feature-intro-item-2.jpg',
                            srcMobile: 'feature-intro-item-2-mobile.jpg',
                            title: 'Individualisierung leicht gemacht',
                            paragraph:
                                'Umfangreiche Optionen für Ihre Route und interessante Orte helfen Ihnen dabei genau das Passende zu finden – ob den günstigsten Dieselpreis in der Umgebung oder Passstraßen, die für Wohnmobile geeignet sind.',
                        },
                        {
                            src: 'feature-intro-item-3.jpg',
                            srcMobile: 'feature-intro-item-3-mobile.jpg',
                            title: 'Gut informiert starten',
                            paragraph:
                                'Werfen Sie einen Blick in die Details Ihrer Route und erhalten Sie hilfreiche Zusatzinfos, wie Maut- & Vignettenkosten, Hinweise auf Umwelt- und Kurzparkzonen, Tempolimits oder Mitführpflichten sowie Verspätungen und Ticketpreise für Öffis.',
                        },
                        {
                            src: 'feature-intro-item-4.jpg',
                            srcMobile: 'feature-intro-item-4-mobile.jpg',
                            title: 'Mit den Öffis unterwegs',
                            paragraph:
                                'Informieren Sie sich im Haltestellenmonitor über die nächsten Abfahrtszeiten oder Verspätungen und erreichen Sie Ihr Ziel auf dem für Sie passenden Weg. Einfach auf Sie abgestimmt!',
                        },
                        {
                            src: 'feature-intro-item-5.jpg',
                            srcMobile: 'feature-intro-item-5-mobile.jpg',
                            title: 'Gemerktes schnell zur Hand',
                            paragraph:
                                'Speichern Sie mithilfe des Stern-Symbols interessante Punkte, Adressen oder geplante Routen. Sie finden diese jederzeit auf der Startseite, um sie schnell und unkompliziert wieder aufrufen zu können.',
                        },
                        {
                            src: 'feature-intro-item-6.jpg',
                            srcMobile: 'feature-intro-item-6-mobile.jpg',
                            title: 'Noch Fragen?',
                            paragraph:
                                'Unter dem [ i ] finden Sie detaillierte Anleitungen, FAQs und Videos zu allen Funktionen sowie weitere hilfreiche Informationen. Schreiben Sie uns, wir freuen uns auf Ihr Feedback!',
                        },
                    ],
                },
                fuelPrices: {
                    title: 'Neue ÖAMTC-Spritpreis Suche',
                    content: [
                        {
                            src: 'fuel-intro-item-0.jpg',
                            srcMobile: 'fuel-intro-item-0-mobile.jpg',
                            title: 'Den günstigsten Sprit auf einen Blick',
                            paragraph:
                                'Sie sehen automatisch alle Tankstellen in Ihrer Nähe nach dem günstigsten Preis sortiert. Nicht zufrieden mit dem Umkreis? Verschieben Sie die Karte, klicken Sie „Hier suchen“ und schon sehen Sie wieder die günstigsten Tankstellen.',
                        },
                        {
                            src: 'fuel-intro-item-1.jpg',
                            srcMobile: 'fuel-intro-item-1-mobile.jpg',
                            title: 'Kraftstoff und Filter einstellen',
                            paragraph:
                                'Mithilfe des Pfeilchens neben der Kraftstoffsorte einfach den Kraftstoff ändern, oder viele weitere Einstellungen tätigen. Egal, ob Sie bei unseren Vorteilspartnern sparen oder einen Shop suchen möchten, bei uns finden Sie immer das Richtige!',
                        },
                        {
                            src: 'fuel-intro-item-2.jpg',
                            srcMobile: 'fuel-intro-item-2-mobile.jpg',
                            title: 'Auch unterwegs immer günstig tanken',
                            paragraph:
                                'Finden Sie auch entlang Ihrer Route immer den günstigsten Spritpreis. Sie können wählen, wie weit Sie von Ihrer Route abweichen, um noch günstigeren Sprit zu finden. Das schont nicht nur Ihre Nerven, sondern auch Ihre Geldbörse!',
                        },
                        {
                            src: 'fuel-intro-item-3.jpg',
                            srcMobile: 'fuel-intro-item-3-mobile.jpg',
                            title: 'Gemerktes schnell zur Hand',
                            paragraph:
                                'Mit Hilfe des Stern-Symbols können Tankstellen gespeichert werden. Unter den “Favoriten” können Sie diese jederzeit schnell und einfach wieder aufrufen. So müssen Sie nie wieder lange suchen, um die aktuellen Preise zu sehen.',
                        },
                        {
                            src: 'fuel-intro-item-4.jpg',
                            srcMobile: 'fuel-intro-item-4-mobile.jpg',
                            title: 'Ortssuche leicht gemacht',
                            paragraph:
                                'Verwenden Sie das Eingabefeld, um Orte oder Bundesländer zu suchen. Alternativ können Sie auch die Karte verschieben und danach auf „Hier suchen“ klicken, schon werden wieder die günstigsten Tankstellen angezeigt.',
                        },
                        {
                            src: 'fuel-intro-item-5.jpg',
                            srcMobile: 'fuel-intro-item-5-mobile.jpg',
                            title: 'Noch Fragen?',
                            paragraph:
                                'Unter dem [ i ] finden Sie detaillierte Anleitungen, FAQs und Videos zu allen Funktionen sowie weitere hilfreiche Informationen. Schreiben Sie uns, wir freuen uns auf Ihr Feedback!',
                        },
                    ]
                }
            }
        };
    },
    created() {
        this.addListeners();
    },
    beforeDestroy() {
        this.removeListeners()
    },
    computed: {
        ...mapGetters(['mobile', 'specialContentFromUrl']),
        dialogTopMargin() {
            return this.mobile ? '16px' : '15vh';
        },
        activeContent() {
            let contentKey = 'default'
            if(this.specialContentFromUrl) {
                contentKey = this.specialContentFromUrl
            }
            return this.contents[contentKey]
        }
    },
    methods: {
        addListeners() {
            eventBus.$on('showFeatureIntroduction', this.showDialog);
        },
        removeListeners() {
            eventBus.$off('showFeatureIntroduction', this.showDialog);
        },
        showDialog() {
            this.dialogVisible = true;
            this.$store.commit('setDialogAlreadyVisible', 'featureIntroduction')
        },
        closeDialog() {
            this.dialogVisible = false;
            this.carouselIndex = 0;
        },
        carouselChange(newIndex) {
            this.carouselIndex = newIndex;
        },
        toNextItem() {
            this.$refs.carousel.next();
        },
        jumpToItem(index) {
            this.$refs.carousel.setActiveItem(index);
        },
        resetCarouselIndex() {
            this.carouselIndex = 0;
            this.$store.commit('setSpecialContentFromUrl', false)
            this.$store.commit('setDialogAlreadyVisible', false)
        },
    },
};
</script>

<style lang="scss">
div .feature-intro {
    &__dialog {
        border-radius: $standard-border-radius;
        max-width: 375px;
        width: calc(100% - 32px);
        z-index: $marker-highest-z + 16 !important;

        .el-dialog {
            &__header {
                padding-top: 12px;
                padding-bottom: 8px;
            }
            &__headerbtn {
                top: 12px;
            }
            &__body {
                padding: 0 0 20px;
            }

            &__title {
                @include caption;
                color: $color-black;
                opacity: 0.5;
            }

            &__close:before {
                color: $color-black;
                font-size: 20px;
                font-weight: $font-weight-bold;
            }
        }

        .el-carousel {
            &__container {
                height: 400px;
            }
        }

        img {
            display: block;
            width: 100%;
        }
    }

    &__text {
        color: $color-black;
        padding: 20px 30px;

        &__title {
            font-size: 16px;
            font-weight: $font-weight-bold;
            line-height: 1.38;
            margin: 0 0 8px;
        }

        &__paragraph {
            font-size: 15px;
            line-height: 1.33;
            margin: 0;
            opacity: 0.5;
            word-break: break-word;
        }
    }

    &__next-button,
    &__close-button {
        margin: 0 30px;
    }

    &__indicators {
        display: flex;
        justify-content: center;
        margin-top: 20px;

        &__indicator {
            border-radius: 50%;
            border: solid 1px $color-grey;
            cursor: pointer;
            margin: 0 6px;
            height: 8px;
            width: 8px;
        }

        .active {
            background-color: $color-grey;
        }
    }
}
</style>
